export const trans_11_1=[
  {
    id:1,
    english:'You should study Vietnamese culture. It is good for you to take a business here',
    vietnamese:'Bạn nên học văn hóa Việt Nam. Điều này rất có lợi bạn có chuyến công tác ở nơi đây',
    user_message:''
  },
  {
    id:2,
    english:'There are a lot of foods, clothes and fruit which are sold in Ha Noi Lotte center',
    vietnamese:'Có rất nhiều đồ ăn, quần áo và hoa quả được bán ở trung tâm Lotte ở Hà Nội',
    user_message:''
  },
  {
    id:3,
    english:'Lan is not as pretty as Russian. but she is very intelligent',
    vietnamese:'Lan không được xinh như Nga. Nhưng cô ấy rất thông minh',
    user_message:''
  },
  {
    id:4,
    english:'The price of your company products is very high. Can you reduce it?',
    vietnamese:'Giá sản phẩm của công ty anh cao quá. Anh có thể giảm xong không?',
    user_message:''
  }, 
  {
    id:5,
    english:'Our products are much cheaper than those in ither countries',
    vietnamese:'Sản phẩm của chúng tôi rẻ hơn nhiều so với các sản phẩm của các quốc gia khác',
    user_message:''
  },

]

export const trans_11_2=[
  {
    id:1,
    english:'What is the weather like in Viet Nam?',
    vietnamese:'Khí hậu Việt Nam như thế nào?',
    user_message:''
  },
  {
    id:2,
    english:'In July, the weather in Ha Noi is hotter than that in Ho Chi Minh',
    vietnamese:'Vào tháng bảy, thời tiết ở Hà Nội nóng hơn thành phố Hồ Chí Minh',
    user_message:''
  },
  {
    id:3,
    english:'Da Lat is very cool in July',
    vietnamese:'Đà Lạt rất mát mẻ vào tháng bảy',
    user_message:''
  },


]